module.exports = __webpack_public_path__ + "img/0080.04baaed4.png";